import { api } from '@goaltree/backend/convex/_generated/api'
import { useConvexAuth, useQuery } from 'convex/react'

export function useIsAdmin() {
  const { isAuthenticated } = useConvexAuth()
  return useQuery(api.admin.amIAdmin, isAuthenticated ? {} : 'skip') === true
}
